import { toSignal } from '@angular/core/rxjs-interop';
import { Observable, Subject, switchMap } from 'rxjs';
import { startWith } from 'rxjs/operators';

export const signalRequestWithRefresh = <T>(request: Observable<T>, initialValue: T) => {
  const refresh$ = new Subject();
  const value = toSignal(
    refresh$.pipe(
      startWith(null),
      switchMap(() => request)
    ),

    { initialValue }
  );

  return { refresh: () => refresh$.next(null), value };
};
